import { TaskItem } from '@tiptap/extension-list'

export type { TaskItemOptions } from '@tiptap/extension-list'
export { TaskItem } from '@tiptap/extension-list'

export default TaskItem
